import {Button} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import {isNonEmptyString, isEmptyString, EmptyString} from 'Core/models/EmptyString';
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {compose} from 'redux';
import {ReducerState} from 'rootReducer';
import Loading from 'Shared/components/Loading';
import RequiredTextInput from 'Shared/components/RequiredTextInput';
import {NoOp} from 'Shared/utilities/IOUtilities';
import {changeUsername, requestQuesForPasswordReset, validUsername} from 'Users/ducks/passwordRecovery';
import './PasswordRecovery.sass';

const PasswordRecovery = () => {
  useEffect(() => {
    localStorage.clear();
  }, []);

  const {username, errorMessage} = useSelector((state: ReducerState) => state.user.passwordRecovery);
  const [clicked, setClicked] = useState(false);
  const dispatch = useDispatch();
  const onChangeUsername = compose(dispatch, changeUsername);
  const onRequestReset = isNonEmptyString(username)
    ? () => {
        dispatch(validUsername(new EmptyString()));
        dispatch(requestQuesForPasswordReset(username));
        dispatch(changeUsername(username));
        setClicked(true);
      }
    : NoOp;

  return (
    <div className="password-recovery">
      <form className="password-recovery__form">
        {isEmptyString(errorMessage) && clicked ? (
          <Loading />
        ) : (
          <>
            <h1>Password Recovery</h1>
            <p>Please enter the username of the account you want to recover below:</p>
            <RequiredTextInput
              className="password-recovery__input"
              onChange={onChangeUsername}
              label="Username"
              value={username}
            />
            {isNonEmptyString(errorMessage) && clicked && (
              <div>
                <Alert severity="error">{errorMessage.value}</Alert>
                <br />
              </div>
            )}
            <Button
              className="btn"
              type="submit"
              onClick={onRequestReset}
              disabled={!isNonEmptyString(username)}
              id="recover-password-button"
              color="primary"
              variant="contained"
            >
              Recover Password
            </Button>
          </>
        )}
      </form>
    </div>
  );
};

export default PasswordRecovery;
